import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import React from "react"

import RouterLink from "../../../helpers/components/RouterLink"
import StyledHTML from "../../../helpers/components/StyledHTML"
import { routes } from "../../../routes/constants/routes"
import { Dashboard_mostRecentCourses } from "../../queries/types/Dashboard"
import RecentCourseList from "./RecentCourseList"

interface Props {
  zeroStateText?: string
  // Null/undefined means the courses never loaded, which is not the same thing
  // as the user owning none of them.
  mostRecentCourses?: Dashboard_mostRecentCourses[] | null
  refetch?: () => void
}

// Only used when no zero state copy has been set in the page editor. Kept in
// step with the My Courses zero state so a new customer sees one message.
const DefaultZeroState = () => (
  <Typography gutterBottom>
    You have not purchased any courses yet. Click{" "}
    <RouterLink to={routes.SHOP.COURSE_LIST} blue>
      HERE
    </RouterLink>{" "}
    to select and purchase a course!
  </Typography>
)

const RecentCourseWrapper = ({
  mostRecentCourses,
  zeroStateText,
  refetch,
}: Props) => {
  const renderContent = () => {
    if (!mostRecentCourses) {
      return (
        <>
          <Typography gutterBottom>
            We could not load your recent courses. Your purchased courses are
            still available under My Courses.
          </Typography>
          {refetch ? (
            <Button onClick={() => refetch()} color="primary">
              Retry
            </Button>
          ) : null}
        </>
      )
    }
    if (mostRecentCourses.length === 0) {
      return zeroStateText ? (
        <Typography component="div" gutterBottom>
          <StyledHTML html={zeroStateText} />
        </Typography>
      ) : (
        <DefaultZeroState />
      )
    }
    return (
      <>
        <RecentCourseList mostRecentCourses={mostRecentCourses} />
        <Typography align="center">
          <RouterLink to={routes.APP.MY_COURSES} blue>
            View All Purchased Courses
          </RouterLink>
        </Typography>
      </>
    )
  }

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        <b>Recent Courses</b>
      </Typography>
      <Card elevation={1}>
        <CardContent>{renderContent()}</CardContent>
      </Card>
    </div>
  )
}

export default RecentCourseWrapper
